import { AUTH_BASE_URL } from 'services/auth/config';
import axiosInstance from 'services/utils/axiosInstance';
import { getCurrentLng } from 'utils/getCurrentLng';

export const emailVerificationService = async (token?: string) => {
  return await axiosInstance.patch(`${AUTH_BASE_URL}/verify-account?lng=${getCurrentLng()}`, {
    token: token
  });
};
